export default function userPermissions(user) {
    const user_permissions = {
        'default': [
            "general",
            "templates",
            "vocabulary",
            "text-modules"
        ],
        'admin': [
            "general",
            "members",
            "billing",
            "templates",
            "vocabulary",
            "text-modules",
            "data",

        ],
        'assistant': [
            "general",
            "templates",
            "vocabulary",
            "text-modules"
        ],
        'doctor': [
            "general",
            "templates",
            "vocabulary",
            "text-modules"
        ]
    }

    if (!user) {
        return user_permissions['default']
    }

    if (!!user.is_admin) {
        return user_permissions['admin']
    }

    return user_permissions[user.role]
}
